import { Dictionary } from '@skylab-shared/types';
import { EventBus } from '../../../event';
import { Tags } from '../../../web';
import { AxiosResponse } from 'axios';
import { Interceptor, InterceptorRequestConfig, IResponse } from '../http.service';
import { isRequestTimeouted } from './timeout-request-interceptor';

export const RequestStatusCode404OccuredEvent = Symbol('shared:request-status-code-404-occured');

export function handle404StatusRequestInterceptor(): Interceptor {
    return {
        request: (config: InterceptorRequestConfig) => {
            if (!config.taggedUrl.hasTag(Tags.NotHandle404) && (config.taggedUrl.hasAnyTag([Tags.Api, Tags.SelloApi]))) {
                const requestId = config.headers?.['X-Request-Id'] as string;
                registerRequest(requestId, config.taggedUrl.tags);
            }
        },
        response: (response: AxiosResponse) => {
            const requestId = response.config?.headers?.['X-Request-Id'] as string;
            unregisterRequest(requestId);
            return response;
        },
        responseError: (error: IResponse) => {
            const requestId = error.config?.headers?.['X-Request-Id'] as string;
            if (!isRequestTimeouted(error) && error.response?.status === 404 && isRegistered(requestId) && !error.config?.taggedUrl?.hasTag(Tags.OmitMessage)) {
                EventBus.emit(RequestStatusCode404OccuredEvent);
            }
            unregisterRequest(requestId);
        }
    };
}

const requests: Dictionary<string[]> = {};

function registerRequest(id: string, tags: string[]): void {
    requests[id] = tags;
}

function unregisterRequest(id: string): void {
    delete requests[id];
}

function isRegistered(id: string): boolean {
    return Object.prototype.hasOwnProperty.call(requests, id);
}
